import React, { useEffect, useState } from 'react';
import './App.css';
import './App.scss';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Header from './components/Header/Header';
import AppContext from './context/AppContext';
import Home from './views/Home/Home';
import Play from './views/Play';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from "./services/config/gamecentreService";
import { storage } from "./services/config/storage";
import { NEW_DATA_EVENT } from './constants/constants';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

function App() {
  // ============= props from parent =============

  // ============= props from redux =============

  // ============= constant variables =============

  // ============= useStates =============
  const [context, setContext] = useState({
    timer: undefined,
    currentLevel: 1,
  });
  const [timer, setTimer] = useState(undefined);
  const [gameStatus, setGameStatus] = useState("no");
  const [header, showHeader] = useState(false);
  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = (window.location !== window.parent.location);
  const [showTutorial, setShowTutorial] = useState(false);

  // ============= useRefs =============

  // ============= computed variables =============

  // ============= custom hooks =============

  // ============= functions =============
  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }

  // ============= useCallback =============

  // ============= useEffects =============
  useEffect(() => {
    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }

    // Adding timeout to handle React.18 intentinonal re-render on development
    const timeout = setTimeout(() => {
      window.addEventListener("message", GC.messageEventHandler);
      window.addEventListener("blur", handleBlur)

      GC.sendGameLoadMessage();
    }, 0);
    window.addEventListener(NEW_DATA_EVENT, syncData);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    };
  }, []);

  /**  
   *  Render game if any two conditions met 
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName } 
  */
  return (
    <div className="App">
      {
        ((!gameInIframe) || (gameDetails)) &&
          <AppContext.Provider value={{ context, setContext, timer, setTimer, header, showHeader,showTutorial,setShowTutorial }}>
          <ErrorBoundary>
            {
              gameStatus === "no" &&
              <Home
                onClick={() => setGameStatus("started")}
              />
            }
            {
              gameStatus === "started" ?
                <React.Fragment>
                  {header && <Header />}
                  <Play
                  />
                </React.Fragment> : null
            }
          </ErrorBoundary>
        </AppContext.Provider>
      }
    </div>
  );
}

export default App;
